<!--
 * @Author: Junchi Zhao
 * @LastEditors: Junchi Zhao
 * @Description:
-->
<template>
  <div class="err">404</div>
</template>

<script>
export default {
  name: 'NotFoundCpt'
};
</script>
<style lang="scss" scoped>
.err {
  font-size: 40px;
  text-align: center;
  width: 100%;
}
</style>
